import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiCalendar, FiClock } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function SchedulesCard() {
return (

<Card className="flex-fill schedule-card">

<Card.Header className="card-header-custom">

<h5>Schedules</h5>

<Link className="text-decoration-none"  to="/candidates-list" >

<Button variant="light" >
View All
</Button></Link>

</Card.Header>

<Card.Body>

{/* Schedule 1 */}

<div className="schedule-box">

<span className="badge badge-ui">UI / UX Designer</span>

<h6>Interview Candidates - UI/UX Designer</h6>

<div className="schedule-date">

<p><FiCalendar className="icon"/> Thu, 15 Feb 2025</p>

<p><FiClock className="icon"/> 01:00 PM - 02:20 PM</p>

</div>

<div className="divider"></div>

<div className="schedule-footer">

<div className="avatar-group">

<img src="/assets/img/users/user-49.jpg" />
<img src="/assets/img/users/user-13.jpg" />
<img src="/assets/img/users/user-11-1.jpg" />
<img src="/assets/img/users/user-22.jpg" />
<img src="/assets/img/users/user-58.jpg" />

<span className="avatar-more">+3</span>

</div>

<Button className="join-btn text-dark">
Join Meeting
</Button>

</div>

</div>


{/* Schedule 2 */}

<div className="schedule-box">

<span className="badge badge-ios">IOS Developer</span>

<h6>Interview Candidates - IOS Developer</h6>

<div className="schedule-date">

<p><FiCalendar className="icon"/> Thu, 15 Feb 2025</p>

<p><FiClock className="icon"/> 02:00 PM - 04:20 PM</p>

</div>

<div className="divider"></div>

<div className="schedule-footer">

<div className="avatar-group">

<img src="/assets/img/users/user-49.jpg" />
<img src="/assets/img/users/user-13.jpg" />
<img src="/assets/img/users/user-11-1.jpg" />
<img src="/assets/img/users/user-22.jpg" />
<img src="/assets/img/users/user-58.jpg" />

<span className="avatar-more">+3</span>

</div>

<Button className="join-btn text-dark">
Join Meeting
</Button>

</div>

</div>

</Card.Body>


<style>
{`

.schedule-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

/* HEADER */

.card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px 20px;
background:#fff;
border-bottom:1px solid #e5e7eb;
}

.card-header-custom h5{
font-size:18px;
font-weight:600;
margin:0;
color:#111827;
}

.view-btn{
border:1px solid #e5e7eb;
background:#f9fafb;
font-size:13px;
}

/* BOX */

.schedule-box{
background:#f8fafc;
padding:12px;
border-radius:8px;
margin-bottom:16px;
}

.schedule-box h6{
font-size:15px;
font-weight:600;
margin-top:8px;
color:#1f2937;
}

/* BADGES */

.badge-ui{
background:#0f4c5c;
color:white;
font-size:11px;
padding:4px 8px;
border-radius:4px;
}

.badge-ios{
background:#111827;
color:white;
font-size:11px;
padding:4px 8px;
border-radius:4px;
}

/* DATE */

.schedule-date{
display:flex;
gap:20px;
font-size:13px;
color:#6b7280;
margin-top:6px;
}

.icon{
margin-right:5px;
}

/* DIVIDER */

.divider{
height:1px;
background:#e5e7eb;
margin:12px 0;
}

/* FOOTER */

.schedule-footer{
display:flex;
justify-content:space-between;
align-items:center;
}

/* AVATARS */

.avatar-group img{
width:30px;
height:30px;
border-radius:50%;
border:2px solid #fff;
margin-left:-10px;
}

.avatar-group img:first-child{
margin-left:0;
}

.avatar-more{
background:#f97316;
color:#fff;
padding:4px 8px;
border-radius:20px;
font-size:12px;
margin-left:6px;
}

/* BUTTON */

.join-btn{
background:#fff;
border:1px solid #e5e7eb;
font-size:14px;
padding:6px 14px;
}

`}
</style>

</Card>

);
}